// 服务申请-主页
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
                  @reload="$reloadHandle"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">

        <div :class="show3===false ? 'active1' : 'no-active2'" style="padding-bottom: 35px">
          <vxe-grid show-overflow height="auto" :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle"
                    :checkbox-config="{ labelField: '', highlight: true, reserve: true , range: true}"
          >

            <template #form>
              <div class="clearfix screen-btns" style=" padding-bottom: 6px;">
                <div class="fl">
                  <vxe-button status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog">新增
                  </vxe-button>
                  <vxe-button status="primary" class="button-sty" icon="el-icon-top"
                              @click="openEditDialog">申请导出
                  </vxe-button>
                </div>
                <div class="fr" style="display: flex;">
                  <el-input placeholder="请输入关键字" style="width: 200px;     height: 27px !important;"
                            v-model="searchValue" @keyup.enter.native="searchEvent" clearable>
                  </el-input>
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 1px;"
                              class="button-sty" @click="searchEvent">搜索
                  </vxe-button>


                </div>
              </div>

              <div class="goodsStatus">
                <div v-for="(item, index) in goodsStatusList" :key="index">
                  <div :class="{
											btnGoodsStatusBt1: goodsStatusIndex == index,
											btnGoodsStatusBt: goodsStatusIndex != index
										}" @click="changeGoodsStatus(item, index)">
                    <span>{{ item.name }}</span> <span class="num_color">{{ item.num }}</span>
                  </div>
                </div>
              </div>

            </template>

            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
    <preconditionDialog v-if="showPreconditionDialog" :visiable.sync="showPreconditionDialog" multi="true"/>

    <preconditionDialog2 v-if="showPreconditionDialog2" :visiable.sync="showPreconditionDialog2" multi="true"/>
  </div>
</template>

<script>
import editView from './edit.vue';
import preconditionDialog from './dialog';
import preconditionDialog2 from './dialog2.vue';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
import api from "@/api/projectApi";

export default {
  inject: ['reload'],
  name: 'apply',
  components: {editView, pager, preconditionDialog, preconditionDialog2},
  data() {
    return {
      total: 0,
      searchValue: null,
      brandOptions: [],
      orderTypeOptions: [],
      serviceTypeOption: [],
      dispatchStatOptions: [],
      areaProps: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      requestParam: {
        brandId: null,
        orderNo: null,
        guaranteeType: null,
        userName: null,
        userMobile: null,
        userType: null,
        stat: null,
        createTimeBegin: null,
        createTimeEnd: null,
        completeTimeBegin: null,
        completeTimeEnd: null,
        searchValueIsEnable: false,
        tabStat: '待处理',

        serverTypeId: null,
        partsStat: null,
        siteId: null,
        createBy: null,
        bookDateBegin: null,
        bookDateEnd: null,
        orderTypeId: null,
        outOrderNo: null,
        dispatchStat: null,

        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
      },
      //////////////////////////////////////////////////////////////
      formData: {
        areaId: null,
        brandId: null,
        orderNo: null,
        guaranteeType: null,
        userName: null,
        userMobile: null,
        userType: null,
        createDate: null,
        createTimeBegin: null,
        createTimeEnd: null,
        completeDate: null,
        completeTimeBegin: null,
        completeTimeEnd: null,
        bookDate: null,
        bookDateBegin: null,
        bookDateEnd: null,
        searchValue: null,
        partsStat: null,
        stat: null,
        orderTypeId: null,
        serviceTypeId: [null],
        siteId: null,
        createBy: null,
        outOrderNo: null,
        managerName: null,
        orgName: null,
        siteName: null,
        dispatchStat: null
      },
      show3: false,

      sitePromptList: [],

      goodsStatusList: [ //循环列表
      ],
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个

      input: '',
      showPreconditionDialog: false,
      //  取消执行
      showPreconditionDialog2: false,

      value2: '',
      value3: '',
      value: '',
      activeName: 'second',
      dataId: 0,

      vxeOption: {},
      // 查询参数


      pageSizes: [10, 20, 100],

      showEdit: false,

      columns: [
        {type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left'},
        {
          width: 100,
          field: 'status',
          fixed: 'right',
          title: '操作',
          showOverflow: true,
          slots: {
            // 使用 JSX 渲染
            default: ({row}) => {
              //单子此时状态  和 能执行的操作     已申诉-此时状态
              if (row.status == 0) {
                return [
                  <div>
                    <a
                      href="javascript:void(0);"
                      class="a-link"
                      onclick={() => {
                        this.openEditDialog(row.id);
                      }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-edit"/>
                      </el-tooltip>
                    </a>

                    <el-dropdown v-on:command={($event) => {
                      this.handleCommand(row, $event)
                    }}>
												<span class="el-dropdown-link">
													<i class="el-icon-arrow-down el-icon--right" style="color:#2a6494"></i>
												</span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="1">列表指派</el-dropdown-item>
                        <el-dropdown-item command="2">地图指派</el-dropdown-item>
                        <el-dropdown-item command="3">指派中心</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                ]
              }
            }
          }
        },

        {
          title: 'CASE单号',
          field: 'caseNo',
          width: 180,
          slots: {
            // 使用 JSX 渲染
            default: ({row}) => {
              return [
                <span style="color: blue"
                      onClick={($event) => this.addressClickEvent(row, $event)}>{row.caseNo}</span>
              ]
            }
          }
        },
        {
          title: 'CASE状态',
          field: 'stat',
          width: 125,
          slots: {
            default: ({row}) => {
              if (row.stat == 0) {
                return [
                  <div class="txt-status neutral">
                    <span>待受理</span>
                  </div>
                ];
              }else if (row.stat == 1) {
                return [
                  <div class="txt-status ">
                    <span>已受理</span>
                  </div>
                ];
              } else if (row.stat == 5) {
                return [
                  <div class="txt-status neutral">
                    <span>跟进中</span>
                  </div>
                ];
              } else if (row.stat == 11) {
                return [
                  <div class="txt-status ">
                    <span>已解决</span>
                  </div>
                ];
              } else if (row.stat == 99) {
                return [
                  <div class="txt-status disable">
                    <span>取消</span>
                  </div>
                ];
              }
            }
          }
        }, {
          title: '来源',
          field: 'orderTypeName',
          width: 100,
          // fixed: 'left'
        },
        {
          title: '服务类型',
          field: 'serverTypeName',
          width: 80,
        },
        {
          title: '服务中心',
          field: 'orgName',
          width: 100,
          // fixed: 'left'
        },
        {
          title: '用户姓名',
          field: 'userName',
          width: 80,
        },
        {
          title: '来电号码',
          field: 'userMobile',
          width: 120,
        },


        {
          title: '地址',
          field: 'fullName',
          width: 180,
        },


        {
          title: '创建时间',
          field: 'createTime',
          width: 150,
        },

      ]
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    },
    'formData.createDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.createTimeBegin = newVal[0]
          this.formData.createTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.createTimeBegin = null
          this.formData.createTimeEnd = null
        }
      },
      deep: true,
    },
    'formData.completeDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.completeTimeBegin = newVal[0]
          this.formData.completeTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.completeTimeBegin = null
          this.formData.completeTimeEnd = null
        }
      },
      deep: true,
    },
    'formData.bookDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.bookDateBegin = newVal[0]
          this.formData.bookDateEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.bookDateBegin = null
          this.formData.bookDateEnd = null
        }
      },
      deep: true,
    },
  },
  created() {
    this.checkButton = this.permissions["checkButton"];
    console.log(this.checkButton, "this.checkButton");
  },

  mounted() {
    this.loadTabOption()
    // this.loadOrderTypeOption()
    this.loadServiceTypeOptions()
    this.loadDispatchStatOptions()
  },

  methods: {
    flushed() {
      this.loadTabOption()
      this.$refs['table-m1'].commitProxy('reload');
    },

    loadDispatchStatOptions() {
      this.$http({
        url: api.basDispatchStat.getList,
        method: 'post',
        data: {
          isShow: 1  //工单查询栏目是否显示:0否1是
        }
      }).then(res => {
        this.dispatchStatOptions = []
        res.data.data.forEach(item => {
          this.dispatchStatOptions.push({label: item.dispatchStat})
        })
      })
    },

    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('selectData', data)
      this.formData.siteId = data.id
    },

    // 获取服务商提示
    querySiteSearch(queryStr, callback) {
      this.$http({
        url: api.snUser.getPromptDataUrl,
        method: 'post',
        data: {userName: queryStr}
      }).then(res => {
        console.log(res.data.data, '网点提示内容')
        let temp = []
        res.data.data.forEach(item => {
          temp.push({value: item.userName, id: item.id})
        })
        callback(temp)
      })
    },

    serviceTypeHandleChange(data) {
      console.log('选中的服务类型数据', data)
    },

    // 加载服务类型
    loadServiceTypeOptions() {
      this.$http({
        url: api.basServiceType.getOptionUrl,
        method: 'post',
        data: {}
      }).then(res => {
        // console.log(res.data.data, 'option')
        let list = [{value: null, label: '全部'}]
        res.data.data.forEach(item => {
          if (item.children.length == 0) {
            delete item.children
          }
          list.push(item)
        })
        this.serviceTypeOption = list
      })
    },

    // // 加载工单来源
    // loadOrderTypeOption() {
    //   this.$http({
    //     url: api.basOrderType.getListUrl,
    //     method: 'post',
    //     data: {}
    //   }).then(res => {
    //     this.orderTypeOptions = []
    //     res.data.data.forEach(item => {
    //       this.orderTypeOptions.push({
    //         value: item.id,
    //         label: item.orderTypeName
    //       })
    //     })
    //   })
    // },

    // 加载tab数据
    loadTabOption() {
      this.$http({
        url: api.soCase.getCountUrl,
        method: 'post',
        data: {}
      }).then(res => {
        this.goodsStatusList = res.data.data
      })
    },

    // 选中的按钮
    changeGoodsStatus(item, index) {
      this.goodsStatusItem = item.name;//获取点击的元素
      this.goodsStatusIndex = index;//将点击元素的下标和：class中的作对比

      this.requestParam.tabStat = this.goodsStatusItem
      this.flushed()
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.soCase.getTableDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      this.requestParam.searchValueIsEnable = !this.show3

      this.requestParam.searchValue = this.searchValue

      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    // 重置
    resetEvent() {
      this.formData = {
        feeType: '',
        name: ''
      }

      this.requestParam.searchCount = false
      this.requestParam.current = 1
      this.requestParam.name = ''
      this.requestParam.feeType = ''

      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        const childrens = response.data.objx || {};
        const nodes = childrens.map(item => ({
          value: item.id,
          label: item.areaName,
          leaf: Number(item.hasChild) > 0
        }))
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes);
      })
    },

    // 地址三级联动
    handleAreaChange() {
      const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
      this.formData.areaId = areaNode[0].value
      const panelRefs = this.$refs.cascaderAddr.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },


    ///////////////////////////////////////////////////////////////////////////////////////////////////


    addressClickEvent(row, id) {
      this.openEditDialog(row.id);
      console.log(row, id, "row");
    },
    // 选中的按钮

    // 考核备注
    open() {
      this.$prompt('请填写考核备注', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        //   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        //   inputErrorMessage: '邮箱格式不正确'
      }).then(({value}) => {
        this.$message({
          type: 'success',
          message: '你的添加的考核备注是: ' + value
        });
        this.reload()// 需要刷新页面
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
        this.reload()// 需要刷新页面
      });

    },
    // 打开考核弹窗
    handleCommand(command, b) {
      console.log(command, b, "command,b的值");
      this.$message('click on item ' + b);
      if (b == 1) {
        this.showPreconditionDialog = true;
      } else if (b == 2) {
        this.open()
      }
    },
    // 打开执行考核弹窗
    handleCommand2(command, b) {
      console.log(command, b, "command,b的值");
      this.$message('click on item ' + b);
      if (b == 1) {
        this.showPreconditionDialog2 = true;
      } else if (b == 2) {
        this.open()
      }
    },
    open() {
      this.$prompt('请填写考核备注', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        //   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        //   inputErrorMessage: '邮箱格式不正确'
      }).then(({value}) => {
        this.$message({
          type: 'success',
          message: '你的添加的考核备注是: ' + value
        });
        this.reload()// 需要刷新页面
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
        this.reload()// 需要刷新页面
      });

    },
    optionChange(value, target) {
      console.log(111, "11111111");
      console.log(value);
      // var select = document.querySelectorAll(".status_select");
      console.log('接受的option的值1', target)
      // var grade = select.options[select.selectedIndex].value;
      // alert(grade);
      // console.log(grade, "grade的值");
      if (target == 2) {

        this.open()


      }


    },

    gradeChange() {
      var objS = document.getElementById("pid");
      var grade = objS.options[objS.selectedIndex].grade;
      alert(grade);
    },

    // // 分页功能
    // changeTablePage(page, flag) {
    //   console.log('分页数据', page, this.formData)
    //   this.formData.size = page.pageSize
    //   this.formData.current = page.currentPage
    //   this.formData.searchCount = flag
    //   this.initTableList();
    // },
    // // 搜索
    // searchEvent() {
    //   this.$refs['table-m1'].commitProxy('reload');
    //
    // },
    // // 重置
    // resetEvent() {
    //   this.formData = {};
    //   this.formData.addresswangdian = {};
    //   this.$refs['table-m1'].commitProxy('reload');
    // },
    // 新增
    openEditDialog(id) {
      console.log(id);
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },

    initTableList() {
      let that = this;
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: '/basic/soCase/getTableDataUrl',
        param: this.formData,
        method: 'post',


      };
      // initVxeTable(tableOption).then(opts => {
      this.vxeOption = initVxeTable(tableOption);

      this.$refs['table-m1'].commitProxy('reload');
    },
  }
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #2a6494;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}


// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}


.active1 {
  // height: 100vh;
  height: calc(100vh - 77px);
  padding-bottom: 29px !important;
}

.no-active2 {
  height: calc(100vh - 70px);
  padding-bottom: 43px !important;
}

#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;

}

// ::v-deep .vxe-grid .vxe-pager {
//     font-size: 12px;
//     height: 25px !important;
// 	// overflow: hidden;
// }
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #FFF;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #EBEEF5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

// 隐藏搜索栏
.screen-box {
  display: flex;


}

::v-deep .vxe-grid .vxe-form.screen-box {
  padding: 4px 10px 2px 0;
}

::v-deep .vxe-grid .vxe-form .vxe-form--item.is--active:not(.is--hidden) {
  display: inline-block;
  width: 20%;
}

::v-deep .vxe-grid .el-input .el-input__inner {
  height: 28px !important;
}
</style>
